import React, { useEffect, useState } from 'react';

import Api from '../../../../interface/api/visit/blacklist';
import { Pagination } from "../../../../component/paging";
import { Page } from "../../../../interface/model/page";
import {Search1} from "../../../../component/search";
import { isValidPhoneNumber } from '../../../../component/visit-application/visit-valid';
import { makeStyles } from '@material-ui/core/styles';
import { Search } from "../../../../interface/model/search";

import {ManagementMenuOptionItem} from "../../../../component/menu-item";
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import {AutoHyphenDelete, AutoHyphenForPhoneNumber, onKeyDownBlock} from "../../../../util/auto-complate";
import {VisitSearchDateComponent} from "../../../../component/visit-application/visit-date";

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: '1px solid #e1e1e1',
        },
    },
});

export default function BlackList() {

    const [ modal, setModal ] = useState<boolean>(false);

    const classes = useRowStyles();

    const [ visitorBlacklist, setVisitorBlacklist ] = useState<Page>();
    const [ pageNumber, setPageNumber ] = useState<number>(0);
    const [ searchInfo , setSearchInfo ] = useState<Search>({
        searchType : 'all',
        searchValue : '',
        searchTypes : [
            {
                key : 'visitorName',
                value : '방문자명'
            },
            {
                key : 'visitorPhone',
                value : '방문자 연락처'
            },
            {
                key : 'blockReason',
                value : '방문 제한 사유'
            },
        ]
    })

    function pageMoveHandler(pageNumber) {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorBlacklistBySearchAndPage(hostInfo.number, searchInfo, pageNumber).then(res => setVisitorBlacklist(res.data));
    }

    function searchHandler() {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorBlacklistBySearchAndPage(hostInfo.number, searchInfo, pageNumber).then(res => setVisitorBlacklist(res.data));
    }

    function createBlacklist(
        visitorName : string,
        visitorPhone : string,
        blockStartDate: string,
        blockEndDate: string,
        blockReason : string) {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.createVisitorBlacklist(hostInfo.number, visitorName, visitorPhone, blockStartDate, blockEndDate, blockReason).then(res => (
            alert("등록 완료 되었습니다.")
        ));
        closeModalHandler();
    }

    function openModalHandler() {
        setModal(true);
    }

    function closeModalHandler() {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorBlacklist(hostInfo.number).then(res =>
            setVisitorBlacklist((prev) =>res.data)
        );
        setModal(false);
    }

    function statusChange (blacklist) {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.updateBlacklistStatus(blacklist, hostInfo).then(() => {
            alert("처리 되었습니다.");
            let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
            Api.getVisitorBlacklist(hostInfo.number).then(res =>
                setVisitorBlacklist((prev) =>res.data)
            );
        });
        return null;
    }

    function renderBlockPeriod(startDate?: string, endDate?: string) {
        // 둘 다 없으면 무기한
        if (!startDate && !endDate) {
            return '무기한';
        }

        // 시작만 있는 경우
        if (startDate && !endDate) {
            return `${startDate} ~`;
        }

        // 종료만 있는 경우 (거의 없겠지만 안전)
        if (!startDate && endDate) {
            return `~ ${endDate}`;
        }

        // 둘 다 있는 경우
        return `${startDate} ~ ${endDate}`;
    }


    useEffect(() => {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorBlacklist(hostInfo.number).then(res => setVisitorBlacklist(res.data));
    }, [])

    return (
        <>
            <div className="add">
                <Search1 searchHandler={searchHandler} searchInfo={searchInfo} setSearchInfo={setSearchInfo} />
                <div className="nv_m_btn_area nv_bord_btn_area" style={{width: 'auto', float: 'right', padding: '25px 20px', margin: '0'}}>
                    <button type="button" className="nv_blue_button right" style={{marginRight: '30px'}} onClick={() => openModalHandler()}>방문 제한자 추가</button>
                </div>
                <div className="nv_table_box adminVersion nv_table_scroll">
                    <TableContainer component={Paper}>
                        <table className={"nv_table"} aria-label="a dense table">
                            <colgroup>
                                <col width={'12.5%'} />
                                <col width={'12.5%'} />
                                <col width={'15%'} />
                                <col width={'40%'} />
                                <col width={'10%'} />
                                <col width={'10%'} />
                            </colgroup>
                            <thead>
                            <tr>
                                <th>방문자</th>
                                <th>연락처</th>
                                <th>제한기간</th>
                                <th>제한사유</th>
                                <th>제한 현황</th>
                                <th>관리</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                visitorBlacklist !== undefined && visitorBlacklist.content.length > 0 ?
                                    visitorBlacklist.content.map((blacklist, index) => (
                                    <>
                                        <tr className={classes.root} key={`blacklistKey${index}`}>
                                            <td align="center">{blacklist.name}</td>
                                            <td align="center">{blacklist.phone}</td>
                                            <td align="center">{renderBlockPeriod(blacklist.blockStartDate, blacklist.blockEndDate)}</td>
                                            <td align="center">{blacklist.blockReason}</td>
                                            <td align="center">{blacklist.blockType === 0 ? '방문 제한' : '제한 해제'}</td>
                                            <td align="center">
                                                <ManagementMenuOptionItem items={[
                                                    {
                                                        innerHTML : blacklist.blockType === 0 ? '제한 해제' : '방문 제한',
                                                        onClickHandler : () => statusChange(blacklist)
                                                    }
                                                ]}/>
                                            </td>
                                        </tr>
                                    </>
                                )) : <tr>
                                        <td colSpan={5} align="center">등록된 방문 제한자가 없습니다.</td>
                                    </tr>
                            }
                            </tbody>
                        </table>
                    </TableContainer>
                    <Pagination page={ visitorBlacklist } pageMoveHandler={ pageMoveHandler } />
                </div>
            </div>
            {
                modal &&
                <AddModal
                    closeModalHandler={closeModalHandler}
                    createBlacklist = {createBlacklist}
                />
            }
        </>
    )
}

function AddModal({closeModalHandler, createBlacklist}) {

    const [visitorName, setVisitorName] = useState('');
    const [visitorPhone, setVisitorPhone] = useState('');
    const [blockStartDate, setBlockStartDate] = useState('');
    const [blockEndDate, setBlockEndDate] = useState('');
    const [blockReason, setBlockReason] = useState('');

    const onChangeVisitorName = e => {
        setVisitorName(e.target.value);
    };

    const onChangeVisitorPhone = e => {
        setVisitorPhone(e.target.value);
    };

    const onChangeBlockReason = e => {
        setBlockReason(e.target.value);
    };

    function onKeyUpHandler(e) {
        let value = AutoHyphenDelete(e.keyCode, e.target.value);
        setVisitorPhone(value);
    }

    function onChangeHandler(e) {
        let value = e.target.value;
        setVisitorPhone(AutoHyphenForPhoneNumber(value));
    }

    function setNewBlacklist() {
        let valid = true;
        if (visitorName.length <= 0) {
            alert(`방문자를 입력해주세요.\r\n ex) 홍길동`);
            valid = false;
        }
        if (!isValidPhoneNumber(visitorPhone)) {
            alert(`연락처를 확인해주세요.\r\n ex) 01011112222`);
            valid = false;
        }
        if (blockReason.length <= 0) {
            alert(`방문 제한 사유를 입력해주세요.\r\n ex) 계약 위반`);
            valid = false;
        }
        if (valid) {
            createBlacklist(visitorName, visitorPhone, blockStartDate, blockEndDate, blockReason);
        }
    }

    return (
        <div className="nv_modal on">
            <div className="nv_modal_container">
                <div className="nv_modal_header">
                    <h2 id="sub_item_title">방문 제한자 추가</h2>
                    <p className="nv_modal_close" onClick={() => closeModalHandler(false)}>닫기</p>
                </div>
                <div className="nv_modal_contents">
                    <table className="nv_table textcenter" id="sub_item_table">
                        <colgroup>
                            <col width={'20%'} />
                            <col width={'40%'} />
                            <col width={'40%'} />
                        </colgroup>
                        <tbody>
                        <tr>
                            <th>방문자</th>
                            <td colSpan={2}>
                                <input className="nv_input" onChange={onChangeVisitorName}/>
                            </td>
                        </tr>
                        <tr>
                            <th>연락처</th>
                            <td colSpan={2}>
                                <input className="nv_input"
                                       value={visitorPhone}
                                       onKeyDown={onKeyDownBlock}
                                       onChange={onChangeHandler}
                                       onKeyUp={onKeyUpHandler}/>
                            </td>
                        </tr>
                        <tr>
                            <th>제한기간</th>
                            <td>
                                <div className="nv_date_box textcenter">
                                    <VisitSearchDateComponent
                                        minDate={null}
                                        selectedHandler={
                                            (date) =>
                                                setBlockStartDate(date)
                                        }
                                    />
                                </div>
                            </td>
                            <td>
                                <div className="nv_date_box">
                                    <VisitSearchDateComponent
                                        minDate={null}
                                        selectedHandler={
                                            (date) =>
                                                setBlockEndDate(date)
                                        }
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>제한사유</th>
                            <td colSpan={2}>
                                <textarea className="nv_textarea" rows={10} cols={30}
                                          onChange={onChangeBlockReason}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <button className="nv_blue_button m_full_btn" style={{float: 'right', margin: '10px 0'}}
                            onClick={setNewBlacklist}>추가
                    </button>
                </div>
            </div>
        </div>
    )

}